
export enum CellType {
    SINGLE, // This cell's value is a single value.
    COLLECTION, // This cell's value is an array.
    EXHAUSTED, // This cell is a filler for adjacent cells that are expanding their children.
    UNEXPANDED // When a collection cell has not been expanded, so we just see a blank cell.
}

/* I store data for one editable "spreadsheet cell" on the page.
*/
export class Cell {
    public _type: CellType = CellType.SINGLE;
    public _value: any = null ; // The type of this can be determined from the column.
    // private _isEdited : boolean;
    // private _infoMessage : string;
    // private _warningMessage : string;
    // private _errorMessage : string;
    // color
    // edited
}